import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { TextLoca } from "../text/TextLoca";
import { ButtonDelete } from "./ButtonDelete";
import { ButtonPrimary } from "./ButtonPrimary";
export var ButtonConfirmation = React.memo(function (props) {
    var onClickCancel = props.onClickCancel, onClickConfirm = props.onClickConfirm;
    return (React.createElement("div", { className: "button-ribbon" },
        React.createElement(ButtonDelete, { onClick: onClickCancel, children: getButtonChildren(IdLoca.cancel) }),
        React.createElement(ButtonPrimary, { onClick: onClickConfirm, children: getButtonChildren(IdLoca.confirm) })));
});
var getButtonChildren = function (loca) { return (React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: loca })); };



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/ButtonConfirmation.tsx
// module id = 609
// module chunks = 3